import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1600000741",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.5882 7.97322C20.8469 8.16139 21 8.46202 21 8.78195V19.0909C21 19.6432 20.5523 20.0909 20 20.0909H2C1.44772 20.0909 1 19.6432 1 19.0909V8.78195C1 8.46202 1.15308 8.16139 1.41183 7.97322L10.4118 1.42776C10.7625 1.17274 11.2375 1.17274 11.5882 1.42776L20.5882 7.97322Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M10.9986 12.8184C13.5077 12.8184 15.544 14.8547 15.544 17.3638V20.0911H6.45312V17.3638C6.45312 14.8547 8.48949 12.8184 10.9986 12.8184Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		})]
	})
});
export default SvgHome;
